// Default required-document checklist per policy type, used by DocRequests
// and the legacy auto-doc generator in deskte-full.jsx.

export const getAutoDocsForClient = (clientId, policies, master, lang) => {
  const clientPols = (policies || []).filter((p) => p.clientId === clientId);
  const seen = new Set();
  const result = [];
  const use = master || REQUIRED_DOCS_BY_POLICY_DEFAULT;
  clientPols.forEach((pol) => {
    const docs = use[pol.type] || REQUIRED_DOCS_BY_POLICY_DEFAULT[pol.type] || [];
    docs.forEach((d) => {
      const displayName = lang === 'es' ? d.nameEs || d.name : d.name;
      const key = displayName.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        result.push({ name: displayName, required: !!d.required, policyType: pol.type });
      }
    });
  });
  return result;
};

export const REQUIRED_DOCS_BY_POLICY_DEFAULT = {
  aca: [
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Proof of Income', nameEs: 'Prueba de Ingresos', required: true },
    { name: 'Proof of Residency', nameEs: 'Prueba de Residencia', required: true },
    { name: 'SSN Card', nameEs: 'Tarjeta del Seguro Social', required: false },
  ],
  ma: [
    { name: 'Medicare Red/White/Blue Card', nameEs: 'Tarjeta de Medicare', required: true },
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Scope of Appointment (SOA)', nameEs: 'Alcance de la Cita (SOA)', required: true },
  ],
  medsup: [
    { name: 'Medicare Card', nameEs: 'Tarjeta de Medicare', required: true },
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
  ],
  partd: [
    { name: 'Medicare Card', nameEs: 'Tarjeta de Medicare', required: true },
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Prescription List', nameEs: 'Lista de Medicamentos', required: false },
  ],
  life: [
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Beneficiary Information', nameEs: 'Informacion de Beneficiarios', required: true },
    { name: 'Proof of Income', nameEs: 'Prueba de Ingresos', required: false },
  ],
  final: [
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Beneficiary Information', nameEs: 'Informacion de Beneficiarios', required: true },
  ],
  dental: [{ name: 'Government ID', nameEs: 'Identificacion Oficial', required: true }],
  vision: [{ name: 'Government ID', nameEs: 'Identificacion Oficial', required: true }],
  accident: [{ name: 'Government ID', nameEs: 'Identificacion Oficial', required: true }],
  suppl: [{ name: 'Government ID', nameEs: 'Identificacion Oficial', required: true }],
  referred: [{ name: 'Government ID', nameEs: 'Identificacion Oficial', required: false }],
  home: [
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Deed or Mortgage Statement', nameEs: 'Escritura o Estado de Hipoteca', required: true },
    { name: 'Prior Declarations Page', nameEs: 'Pagina de Declaraciones Previa', required: false },
  ],
  auto: [
    { name: "Driver's License", nameEs: 'Licencia de Conducir', required: true },
    { name: 'Vehicle Registration', nameEs: 'Registro del Vehiculo', required: true },
    { name: 'Prior Declarations Page', nameEs: 'Pagina de Declaraciones Previa', required: false },
  ],
  renters: [
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Lease Agreement', nameEs: 'Contrato de Arrendamiento', required: false },
  ],
  commercial: [
    { name: 'Business License', nameEs: 'Licencia de Negocio', required: true },
    { name: 'EIN / Tax ID', nameEs: 'EIN / ID Fiscal', required: true },
    { name: 'Prior Declarations Page', nameEs: 'Pagina de Declaraciones Previa', required: false },
  ],
  umbrella: [
    { name: 'Existing Auto Declarations', nameEs: 'Declaraciones de Auto Existentes', required: true },
    { name: 'Existing Home Declarations', nameEs: 'Declaraciones de Hogar Existentes', required: true },
  ],
  pet: [
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Pet Medical Records', nameEs: 'Historial Medico de la Mascota', required: true },
    { name: 'Pet Vaccination Records', nameEs: 'Registro de Vacunas de la Mascota', required: false },
    { name: 'Pet Photo', nameEs: 'Foto de la Mascota', required: false },
  ],
  travel: [
    { name: 'Government ID', nameEs: 'Identificacion Oficial', required: true },
    { name: 'Passport', nameEs: 'Pasaporte', required: true },
    { name: 'Travel Itinerary', nameEs: 'Itinerario de Viaje', required: true },
    { name: 'Flight/Hotel Confirmation', nameEs: 'Confirmacion de Vuelo/Hotel', required: false },
  ],
};
